import React, { FC } from "react";
import styles from "./structure-modal.module.scss";
import Button from "../../../components/ui-kit/button/button";
import Modal from "../../../shared/modal/modal";
import { getStructureFiles } from "../../../services/api";
import { useTranslation } from "react-i18next";

interface StructureModalProps {
  onClose: () => void;
}

const StructureModal: FC<StructureModalProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const handleDownload = async () => {
    try {
      await getStructureFiles();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      className={styles.structureModal}
      closeClass={styles.closeBtn}
      onClose={onClose}
    >
      <div className={styles.content}>
        <h1 className={styles.title}>{t("repository.structureDownload")}</h1>
        <span className={styles.description}>
          {t("repository.structureDescriptionModal").replaceAll("\n", "\n")}
        </span>
        <div className={styles.groupBtn}>
          <Button onClick={handleDownload} type="primary">
            {t("repository.downloadStructure")}
          </Button>
          <Button onClick={onClose} type="outline">
            {t("repository.cancel")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default StructureModal;
